import { render, staticRenderFns } from "./SupportTicket.vue?vue&type=template&id=c44cc156&scoped=true"
import script from "./SupportTicket.vue?vue&type=script&lang=js"
export * from "./SupportTicket.vue?vue&type=script&lang=js"
import style0 from "./SupportTicket.vue?vue&type=style&index=0&id=c44cc156&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44cc156",
  null
  
)

export default component.exports